import React, { useState } from 'react';

function Legislacao() {
    const [legislacoes, setLegislacoes] = useState([
        {
            texto: () => (
                <div className='mb-2'>
                    <p>
                        <a href="https://legislacao.prefeitura.sp.gov.br/leis/lei-17433-de-29-de-julho-de-2020" target='_blank'>Lei nº 17.433/20</a> - criou a  Agência Reguladora de Serviços Públicos do Município de São Paulo – SP Regula,
                        sob a forma de autarquia em regime especial vinculada ao Gabinete do Prefeito, que possui autonomia administrativa,
                        financeira e orçamentária, sendo responsável pela regulação e fiscalização dos serviços delegados da cidade de São Paulo,
                        e ainda os Decretos 60.173/2021, 61.425/2022; 60.941/2021 e 61.036/2022,
                        que estabelecem dentre outras as competências e atribuições para os serviços de limpeza urbana bem como as posturas municipais.
                    </p>
                    <p>
                        A SP REGULA cabe a fiscalização dos serviços delegados, autorizados consoante a Lei 17.433/20 bem como os decretos regulamentadores 60.173/2021; 61.425/2022; 60.941/2021 e 61.036/2022
                    </p>
                </div>
            )
        },
        {
            texto: () => (
                <div className='mb-2'>
                    <p>
                        <a href="http://legislacao.prefeitura.sp.gov.br/leis/lei-13478-de-30-de-dezembro-de-2002" target='_blank'>Lei nº 13.478/2002</a>  - Dispõe sobre a organização do Sistema de Limpeza Urbana do Município de São Paulo;
                        cria e estrutura seu órgão regulador;
                        autoriza o Poder Público a delegar a execução dos serviços públicos mediante concessão ou permissão; institui a Taxa de Resíduos Sólidos Domiciliares - TRSD,
                        a Taxa de Resíduos Sólidos de Serviços de Saúde - TRSS e a Taxa de Fiscalização dos Serviços de Limpeza Urbana - FISLURB;
                        cria o Fundo Municipal de Limpeza Urbana - FMLU, e dá outras providências.
                    </p>
                </div>
            )
        },
        {
            texto: () => (
                <div className='mb-2'>
                    <p>
                        <a href="https://legislacao.prefeitura.sp.gov.br/leis/lei-17433-de-29-de-julho-de-2020" target='_blank'>Lei nº 17.433/2020</a> - Dispõe sobre a reorganização da Administração Pública Municipal Indireta, incluindo a criação da Agência Reguladora de Serviços Públicos do Município de São Paulo – SP Regula.
                    </p>
                </div>
            )
        },
        {
            texto: () => (
                <div className='mb-2'>
                    <p>
                        <a href="https://legislacao.prefeitura.sp.gov.br/leis/lei-17433-de-29-de-julho-de-2020" target='_blank'>Lei nº 14.803/2008</a> - Dispõe sobre o Plano Integrado de Gerenciamento dos Resíduos da Construção Civil e Resíduos Volumosos e seus componentes, o Programa Municipal de Gerenciamento e Projetos de Gerenciamento de Resíduos da Construção Civil conforme previstos na Resolução CONAMA nº 307/2002, disciplina a ação dos geradores e transportadores destes resíduos no âmbito do Sistema de Limpeza Urbana do Município de São Paulo e dá outras providências.
                    </p>
                </div>
            )
        },
        {
            texto: () => (
                <div className='mb-2'>
                    <p>
                        <a href="https://legislacao.prefeitura.sp.gov.br/leis/decreto-60941-de-23-de-dezembro-de-2021" target='_blank'>Decreto nº 60.941/2021</a> - Dispõe sobre a inventariança e a transferência de direitos, obrigações e de bens da Autoridade Municipal de Limpeza Urbana - AMLURB, especifica as competências definidas no Decreto nº 60.353, de 30 de junho de 2021, e altera disposições.
                    </p>
                </div>
            )
        },
        {
            texto: () => (
                <div className='mb-2'>
                    <p>
                        <a href="https://legislacao.prefeitura.sp.gov.br/leis/decreto-61425-de-9-de-junho-de-2022" target='_blank'>Decreto nº 61.425/2022</a> - Dispõe sobre o Regimento Interno da Agência Reguladora de Serviços Públicos do Município de São Paulo - SP Regula.
                    </p>
                </div>
            )
        },
        {
            texto: () => (
                <div className='mb-2'>
                    <p>
                        <a href="https://legislacao.prefeitura.sp.gov.br/leis/decreto-61036-de-7-de-fevereiro-de-2022" target='_blank'>Decreto nº 61.036/2022</a> - Dispõe sobre a reorganização da Secretaria Executiva de Planejamento e Entregas Prioritárias – SEPEP, da Secretaria de Governo Municipal, e a criação e organização da Secretaria Executiva de Limpeza Urbana – SELIMP, na Secretaria Municipal das Subprefeituras, bem como altera a denominação e a lotação dos cargos de provimento em comissão que especifica.
                    </p>
                </div>
            )
        },
        {
            texto: () => (
                <div className='mb-2'>
                    <p>
                        <a href="http://legislacao.prefeitura.sp.gov.br/leis/decreto-46594-de-03-de-novembro-de-2005" target='_blank'>Decreto nº 46.594/2005</a> - REGULAMENTA, DE ACORDO COM A RESOLUÇÃO CONAMA Nº 307, DE 5 DE JULHO DE 2002, A COLETA, O TRANSPORTE, O TRATAMENTO E A DISPOSIÇÃO FINAL DOS RESÍDUOS DA CONSTRUÇÃO CIVIL, DE QUE TRATA A LEI Nº 13.478, DE 30 DE DEZEMBRO DE 2002, COM AS ALTERAÇÕES POSTERIORES. (Redação dada pelo Decreto nº 57.662/2017).
                    </p>
                </div>
            )
        },
        {
            texto: () => (
                <div className='mb-2'>
                    <p>
                        <a href="https://legislacao.prefeitura.sp.gov.br/leis/decreto-57662-de-13-de-abril-de-2017" target='_blank'>Decreto nº 57.662/2017</a> - Introduz alterações no Decreto nº 46.594, de 3 de novembro de 2005, que regulamenta a coleta, o transporte, o tratamento e a disposição final de resíduos inertes, de que trata a Lei nº 14.478, de 30 de dezembro de 2002, com suas alterações subsequentes.
                    </p>
                </div>
            )
        },
        {
            texto: () => (
                <div className='mb-2'>
                    <p>
                        <a href="https://legislacao.prefeitura.sp.gov.br/leis/decreto-58701-de-4-de-abril-de-2019" target='_blank'>Decreto nº 58.701/2019</a> - Regulamenta os artigos 123, 140, 141 e 142 da Lei nº 13.478, de 30 de dezembro de 2002, que dispõe sobre a organização do Sistema de Limpeza Urbana do Município de São Paulo, fixa competências voltadas à fiscalização das posturas municipais e à aplicação das respectivas penalidades previstas na referida lei, bem como revoga os decretos que especifica.
                    </p>
                </div>
            )
        },
        {
            texto: () => (
                <div className='mb-2'>
                    <p>
                        <a href="https://www.gov.br/anvisa/pt-br/centraisdeconteudo/publicacoes/servicosdesaude/publicacoes/rdc-222-de-marco-de-2018-comentada.pdf" target='_blank' rel='noopener noreferrer'>RDC ANVISA nº 222/2018</a> - Contém orientações sobre o gerenciamento e descarte de resíduos de serviços de saúde, especialmente dos resíduos infectantes.
                    </p>
                </div>
            )
        },
        {
            texto: () => (
                <div className='mb-2'>
                    <p>
                        <a href="https://legislacao.prefeitura.sp.gov.br/resolucao-agencia-reguladora-de-servicos-publicos-do-municipio-de-sao-paulo-sp-regula-22-de-5-de-fevereiro-de-2024" target='_blank' rel='noopener noreferrer'>Resolução SP Regula nº 22/2024</a> - Dispõe sobre a implantação do sistema informatizado de Fiscalização, estabelece os procedimentos administrativos fiscalizatórios e sancionatórios aplicáveis aos prestadores de serviços sujeitos à fiscalização e regulação da Agência Reguladora de Serviços Públicos do Município de São Paulo – SP Regula, e dá outras providências.
                    </p>
                </div>
            )
        }
    ]);

    return <div>
        {legislacoes.map((value, index) => {
            const Component = value.texto;
            return <div key={index} className=' mb-2 rounded p-2' style={{ border: "2px solid #b6b3b3" }}>
                <Component />
            </div>
        })}
    </div>
}

export default Legislacao;